import { ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import CaseStudyTabs from "../components/CaseStudyTabs";
import { LaptopFrame, PhoneFrame } from "../components/DeviceMockups";

export default function FeaturedProject() {
  return (
    <section data-testid="featured-project-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
          <div className="order-2 lg:order-1 lg:col-span-6">
            <Reveal>
              <div className="relative">
                <div
                  className="absolute -inset-12 -z-10 opacity-70"
                  style={{ background: "radial-gradient(closest-side, rgba(37,99,235,0.14), transparent)" }}
                  aria-hidden="true"
                />
                <LaptopFrame
                  src="/assets/drtran-desktop.jpg"
                  alt="Dr. Tran College Consulting — desktop website designed and developed by AT Digital"
                />
                <PhoneFrame
                  src="/assets/drtran-mobile.jpg"
                  alt="Dr. Tran College Consulting — mobile website view"
                  className="absolute -bottom-8 -right-2 w-28 sm:-right-6 sm:w-36"
                />
              </div>
            </Reveal>
          </div>
          <div className="order-1 lg:order-2 lg:col-span-6">
            <Reveal>
              <p className="font-mono text-xs font-semibold tracking-[0.3em] text-gold">FEATURED PROJECT</p>
              <h2 className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
                From complex business
                <br />
                to simple story.
              </h2>
              <p className="mt-3 font-display text-lg font-semibold text-slate-200">
                Dr. Tran College Consulting
              </p>
              <p className="mt-1.5 font-mono text-[11px] font-medium tracking-[0.2em] text-royal">
                WEBSITE DESIGN &amp; DEVELOPMENT
              </p>
            </Reveal>
            <Reveal delay={0.1} className="mt-8">
              <CaseStudyTabs />
            </Reveal>
            <Reveal delay={0.2} className="mt-9 flex flex-wrap gap-4">
              <a
                href="https://drtrancollegeconsulting.net/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="featured-project-view-live-btn"
                className="group inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 text-sm font-bold text-ink transition-colors duration-300 hover:bg-goldlight"
              >
                View the Live Experience
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </a>
              <a
                href="/work"
                data-testid="featured-project-case-study-btn"
                className="inline-flex items-center gap-2 rounded-full border border-navyline px-7 py-3.5 text-sm font-semibold text-slate-200 transition-colors duration-300 hover:border-gold/60 hover:text-gold"
              >
                Read the Case Study
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
